import styles from './UpsaleButton.module.scss';
import cn from 'classnames';
export const UpsaleButton = ({hide, children, className, status, ...props }) => {
  return (
    <div className={cn(
      styles.button, 
      className, 
      status === "disabled" && styles.disabled,
      hide && styles.hide
    )} {...props}>{children || "Continue"}</div>
  )
}